import { __read } from "tslib";
import { combineLatest, connect, distinctUntilChanged, filter, map, pipe, prop, stream, streamFromEmitter, system, tup, } from '@virtuoso.dev/urx';
import { findMaxKeyValue } from './AATree';
import { domIOSystem } from './domIOSystem';
import { hasGroups, sizeSystem } from './sizeSystem';
export function groupCountsToIndicesAndCount(counts) {
    return counts.reduce(function (acc, groupCount) {
        acc.groupIndices.push(acc.totalCount);
        acc.totalCount += groupCount + 1;
        return acc;
    }, {
        totalCount: 0,
        groupIndices: [],
    });
}
export var groupedListSystem = system(function (_a) {
    var _b = __read(_a, 2), _c = _b[0], totalCount = _c.totalCount, groupIndices = _c.groupIndices, sizes = _c.sizes, _d = _b[1], scrollTop = _d.scrollTop, headerHeight = _d.headerHeight;
    var groupCounts = stream();
    var topItemsIndexes = stream();
    var groupIndicesAndCount = streamFromEmitter(pipe(groupCounts, map(groupCountsToIndicesAndCount)));
    connect(pipe(groupIndicesAndCount, map(prop('totalCount'))), totalCount);
    connect(pipe(groupIndicesAndCount, map(prop('groupIndices'))), groupIndices);
    connect(pipe(combineLatest(scrollTop, sizes, headerHeight), filter(function (_a) {
        var _b = __read(_a, 2), sizes = _b[1];
        return hasGroups(sizes);
    }), map(function (_a) {
        var _b = __read(_a, 3), scrollTop = _b[0], state = _b[1], headerHeight = _b[2];
        return findMaxKeyValue(state.groupOffsetTree, Math.max(scrollTop - headerHeight, 0), 'v')[0];
    }), distinctUntilChanged(), map(function (index) { return [index]; })), topItemsIndexes);
    return { groupCounts: groupCounts, topItemsIndexes: topItemsIndexes };
}, tup(sizeSystem, domIOSystem));
